import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { bool, object, func, string } from 'prop-types';
import { Container } from './login-menu.styles';
import { UnsignedUserState, SignedUserState } from './subcomponents';
/**
 * Styled-system Compatible
 * https://styled-system.com/api
 */

const LoginMenu = ({
  isSignedIn,
  unsignedConfig,
  signedConfig,
  signOutUrl,
  onLogout,
  onUnsignedClick,
  onSignedHover,
  onSignedMenuClick
}) => {
  return /*#__PURE__*/React.createElement(Container, null, isSignedIn ? /*#__PURE__*/React.createElement(SignedUserState, _extends({}, signedConfig, {
    signOutUrl: signOutUrl,
    onLogout: onLogout,
    handleSignedHover: onSignedHover,
    handleSignedMenuClick: onSignedMenuClick
  })) : /*#__PURE__*/React.createElement(UnsignedUserState, _extends({}, unsignedConfig, {
    handleUnsignedClick: onUnsignedClick
  })));
};

process.env.NODE_ENV !== "production" ? LoginMenu.propTypes = {
  isSignedIn: bool,
  unsignedConfig: object.isRequired,
  signedConfig: object.isRequired,
  signOutUrl: string,
  onLogout: func.isRequired,
  onUnsignedClick: func,
  onSignedHover: func,
  onSignedMenuClick: func
} : void 0;
LoginMenu.defaultProps = {
  isSignedIn: false,
  unsignedConfig: {},
  signedConfig: {},
  onLogout: () => {},
  onUnsignedClick: () => {},
  onSignedHover: () => {},
  onSignedMenuClick: () => {},
  signOutUrl: ''
};
export default LoginMenu;